import apiUrl from "./apiUrl";

export const uploadImageToBackend = async (
  file: File,
  folder: string = "misc"
) => {
  const formData = new FormData();
  formData.append("image", file);
  formData.append("folder", folder);

  const response = await fetch(`${apiUrl}/upload-image/`, {
    method: "POST",
    body: formData,
  });

  if (!response.ok) throw new Error("Image upload failed");
  const data = await response.json();
  return data.url;
};
